import { useContext, useEffect, useState } from "react";
import { singletonHook } from "react-singleton-hook";
import { DomainConfigContext } from "react-builder";

export interface SportVideo {
    "id": 286,
    "name": "Football Heroes Episode 8",
    "title": "Football Heroes Episode 8",
    "description": "World Cup 2014: the most anticipated event in World Football. Get ready with Football Heroes, a compilation of half-hour episodes devoted to star players of the worlds most loved sport. Covering everyone from the great legends to those who are just beginning, but who are surely destined for fame & fortune.",
    "duration": null,
    "genre": "sport",
    "category": "soccer",
    "subCategory": null,
    "movieUrl": "https://sportsmovies.s3.amazonaws.com/movies/01W5FOOTBALL_HEROES_EP08.mp4",
    "trailerUrl": "",
    "previewUrl": "https://sportsmovies.s3.amazonaws.com/thumbnail/01W5FOOTBALL_HEROES_EP08.jpg",
    "mobileUrl": null,
    "tagsId": any[]
}

export const useSportVideos = singletonHook<{ videos: SportVideo[], addVideo: (v: SportVideo) => void, videosByCategory: { category: string, videos: SportVideo[] }[], loadVideos: () => Promise<SportVideo[]> }>({} as any, function () {

    const domain = useContext(DomainConfigContext);
    const [videos, setVideos] = useState<SportVideo[]>([]);
    const [videosByCategory, setVideosByCategory] = useState<{ category: string, videos: SportVideo[] }[]>([]);
    const [videoPromise, setVideoPromise] = useState<Promise<SportVideo[]> | undefined>();


    const addVideo = function (video: SportVideo) {
        setVideos([...videos, video]);
    }
    const loadVideos = (): Promise<SportVideo[]> => {

        // in progress
        if (videoPromise) return videoPromise;

        var myHeaders = new Headers();
        myHeaders.append("accept", "application/json, text/plain, */*");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
        };

        const p = fetch(`${domain?.apiEndpoint}rest/movies/genre/sport`, requestOptions)
            .then(response => response.json())

            .then((result) => {
                setVideos(result as SportVideo[]);
                return result as SportVideo[];
            })
            .catch(error => {
                return [] as SportVideo[];
            }).finally(() => {
                setVideoPromise(undefined);
            });
        setVideoPromise(p)
        return p;
    }

    useEffect(() => {

        const map: { [key: string]: SportVideo[] } = videos.reduce((map: any, item) => {
            if (item.category) {
                map[item.category!] = map[item.category!] || [];
                map[item.category!].push(item);
            }
            return map;
        }, {});
        setVideosByCategory([{ category: 'All Genres', videos: videos }, ...Object.keys(map).map((key, i) => ({ category: key, videos: map[key] }))]);
    }, [videos]);

    return { videos, addVideo, loadVideos, videosByCategory };
});